import { render } from "./service-categories.vue?vue&type=template&id=3317533d&scoped=true"
import script from "./service-categories.vue?vue&type=script&lang=js"
export * from "./service-categories.vue?vue&type=script&lang=js"

import "./service-categories.vue?vue&type=style&index=0&id=3317533d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3317533d"]])

export default __exports__